import { objectKeys } from '@coxy/utils'
import { configureStore } from '@reduxjs/toolkit'
import { initApiInterceptors } from '@shared-core/services/api/init-interceptors'
import { listenerMiddleware } from '@shared-core/store/listener-middleware'
import '@shared-core/store/middlewares'
import { reducers, slices } from '@shared-core/store/reducers'
import * as thunk from 'redux-thunk'

export const createStore = (preloadedState: object, additionalReducers = {}) => {
  const initialReducers = {
    ...reducers,
    ...additionalReducers,
  }

  // Не передаём в Redux слайсы от старой версии приложения.
  objectKeys(preloadedState).forEach((storeKey) => {
    if (!Object.hasOwn(initialReducers, storeKey)) {
      delete (preloadedState as Record<string, unknown>)[storeKey]
    }
  })

  // restore initial state
  objectKeys(preloadedState).forEach((storeKey) => {
    if (!Object.hasOwn(initialReducers, storeKey)) return

    const typedStoreKey = storeKey as keyof typeof initialReducers
    const initialStoreData = slices?.[typedStoreKey]?.getInitialState() || {}
    const currentStateStore = (preloadedState as never)[typedStoreKey]

    objectKeys(initialStoreData).forEach((initialKey) => {
      if (currentStateStore[initialKey] === undefined) {
        currentStateStore[initialKey] = initialStoreData[initialKey]
      }
    })
  })

  const store = configureStore({
    reducer: initialReducers,
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware({
        serializableCheck: false,
        actionCreatorCheck: false,
        immutableCheck: false,
      }).concat(listenerMiddleware.middleware, thunk.withExtraArgument({}))
    },
    preloadedState,
  })

  // API interceptors (refresh/retry)
  initApiInterceptors(store)

  return store
}
